import { Component } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { AdminService } from '@app/modules/admin/services/admin.service';
import { AppService } from '@app/services/app.service';
import { AuthService } from '@app/services/auth.service';
import { TranslocoService } from '@jsverse/transloco';
import { ConfirmationPopupComponent } from '../login/confirmation-popup/confirmation-popup.component';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.scss',
  standalone: false
})
export class ResetPasswordComponent {
  resetForm!: FormGroup;
  uid: any;
  errMessage!: string;
  loading!: boolean;
  isMobile = false;
  show = false;
  loginHost: any;
  showDefaultResetPassword: boolean = false;
  showCbreResetPassword: boolean = false;
  showSensesResetPassword: boolean = false;
  isForget = false;
  invalidLoginMessage!: any;
  hide = true;


  organizationDetails: any;
  defaultOrganizationDetail: any;
  loaded: boolean = false;
  s3Url: any;

  themeConfig: any = {
    logos: {
      "banner": {
        "img": "/organizationLogos/ffecf755-3f37-4548-aa19-4be1b0144610.jpg",
        "loading": false
      },
      "logo3": {
        "img": "/organizationLogos/2bd14798-a7b5-425b-83eb-c022f589b67d.png",
        "loading": false
      },
      "logo2": {
        "img": "/organizationLogos/724bb680-8ddf-4cbf-a5c9-a79d80afea71.png",
        "loading": false
      },
      "logo1": {
        "img": "/organizationLogos/875bb0c8-13d6-4092-a808-ed6dddab07bc.png",
        "loading": false
      }
      // logo2: "assets/img/senses-logo.png",
    },
    bgAndFontColor: {
      "header": {
        "text": "#ffffff",
        "font": 'Roboto, "Helvetica Neue", sans-serif',
        "bold": false,
        "bg": [
          "#e26063",
          "#c32124"
        ]
      },
      "dashboard": {
        "text": "#ffffff",
        "font": 'Roboto, "Helvetica Neue", sans-serif',
        "bold": false,
        "inBox": true,
        "bg": [
          "#c32124"
        ]
      },
      "sidebar": {
        "text": "#ffffff",
        "font": 'got_med',
        "bold": false,
        "activeBg": [
          "#e26063"
        ],
        "bg": [
          "#c32124"
        ]
      },
      "default": {
        "font": "OCR A Std, monospace",
        "btnBorder": false,
        "btnType": "",
        "text": "#c32124",
        "primary": "#c32124",
        "heading": "#c32124",
        "icon": "#c32124",
        "bg": [
          "#f1eaeb"
        ],
        "primaryBtn": {
          "text": "#ffffff",
          "bg": [
            "#c32124"
          ],
        },
        "secondaryBtn": {
          "text": "#ffffff",
          "bg": [
            "#e26063"
          ],
        },
        "cancelBtn": {
          "text": "#c32124",
          "bg": [
            "#ffffff"
          ],
        },
        "infoBtn": {
          "text": "#f44239",
          "bg": [
            "#f5fb4d"
          ],
        },
        "warningBtn": {
          "text": "#ffffff",
          "bg": [
            "#f44239"
          ],
        },
        "successBtn": {
          "text": "#ffffff",
          "bg": [
            "#36834f"
          ],
        },
      },
      "notification": {
        "text": "#ffffff",
        "heading": "#ffffff",
        "font": 'Roboto, "Helvetica Neue", sans-serif',
        "bold": false,
        "bg": [
          "#c32124"
        ]
      },
      "account": {
        "text": "#ffffff",
        "font": 'Roboto, "Helvetica Neue", sans-serif',
        "bold": false,
        "bg": [
          "#c32124"
        ]
      },
      "login": {
        "desktop": {
          "page": '1',
          "btnType": "",
          "font": "",
          "radius": true,
          "circleFlag": false,
          "toAll": false,
          "btnText": "#ffffff",
          "heading": "#ffffff",
          "text": "#000000",
          "bg": [
            "#e26063",
            "#c32124"
          ],
          "btnBg": [
            "#e26063",
            "#c32124"
          ]
        },
        "mobile": {
          "page": '1',
          "btnType": "",
          "font": "",
          "radius": true,
          "circleFlag": false,
          "toAll": false,
          "btnText": "#ffffff",
          "heading": "#ffffff",
          "text": "#000000",
          "bg": [
            "#e26063",
            "#c32124"
          ],
          "btnBg": [
            "#e26063",
            "#c32124"
          ]
        },
      }
    }
  }

  data: any = {
    logos: {
      "banner": {
        "img": "/organizationLogos/ffecf755-3f37-4548-aa19-4be1b0144610.jpg",
        "loading": false
      },
      "logo3": {
        "img": "/organizationLogos/2bd14798-a7b5-425b-83eb-c022f589b67d.png",
        "loading": false
      },
      "logo2": {
        "img": "/organizationLogos/724bb680-8ddf-4cbf-a5c9-a79d80afea71.png",
        "loading": false
      },
      "logo1": {
        "img": "/organizationLogos/875bb0c8-13d6-4092-a808-ed6dddab07bc.png",
        "loading": false
      }
      // logo2: "assets/img/senses-logo.png",
    },
    bgAndFontColor: {
      "header": {
        "text": "#ffffff",
        "font": 'Roboto, "Helvetica Neue", sans-serif',
        "bold": false,
        "bg": [
          "#e26063",
          "#c32124"
        ]
      },
      "dashboard": {
        "text": "#ffffff",
        "font": 'Roboto, "Helvetica Neue", sans-serif',
        "bold": false,
        "inBox": true,
        "bg": [
          "#c32124"
        ]
      },
      "sidebar": {
        "text": "#ffffff",
        "font": 'got_med',
        "bold": false,
        "activeBg": [
          "#e26063"
        ],
        "bg": [
          "#c32124"
        ]
      },
      "default": {
        "font": "OCR A Std, monospace",
        "btnBorder": false,
        "btnType": "",
        "text": "#c32124",
        "primary": "#c32124",
        "heading": "#c32124",
        "icon": "#c32124",
        "bg": [
          "#f1eaeb"
        ],
        "primaryBtn": {
          "text": "#ffffff",
          "bg": [
            "#c32124"
          ],
        },
        "secondaryBtn": {
          "text": "#ffffff",
          "bg": [
            "#e26063"
          ],
        },
        "cancelBtn": {
          "text": "#c32124",
          "bg": [
            "#ffffff"
          ],
        },
        "infoBtn": {
          "text": "#f44239",
          "bg": [
            "#f5fb4d"
          ],
        },
        "warningBtn": {
          "text": "#ffffff",
          "bg": [
            "#f44239"
          ],
        },
        "successBtn": {
          "text": "#ffffff",
          "bg": [
            "#36834f"
          ],
        },
      },
      "notification": {
        "text": "#ffffff",
        "heading": "#ffffff",
        "font": 'Roboto, "Helvetica Neue", sans-serif',
        "bold": false,
        "bg": [
          "#c32124"
        ]
      },
      "account": {
        "text": "#ffffff",
        "font": 'Roboto, "Helvetica Neue", sans-serif',
        "bold": false,
        "bg": [
          "#c32124"
        ]
      },
      "login": {
        "desktop": {
          "page": '1',
          "btnType": "",
          "font": "",
          "radius": true,
          "circleFlag": false,
          "toAll": false,
          "btnText": "#ffffff",
          "heading": "#ffffff",
          "text": "#000000",
          "bg": [
            "#e26063",
            "#c32124"
          ],
          "btnBg": [
            "#e26063",
            "#c32124"
          ]
        },
        "mobile": {
          "page": '1',
          "btnType": "",
          "font": "",
          "radius": true,
          "circleFlag": false,
          "toAll": false,
          "btnText": "#ffffff",
          "heading": "#ffffff",
          "text": "#000000",
          "bg": [
            "#e26063",
            "#c32124"
          ],
          "btnBg": [
            "#e26063",
            "#c32124"
          ]
        },
      }
    }
  }

  constructor(private route: ActivatedRoute, private authService: AuthService, private translocoService: TranslocoService,
    private snackBar: MatSnackBar, private router: Router,
    // private adminService: AdminService
    private appService: AppService,
    private dialog: MatDialog,

  ) { }

  ngOnInit() {

    this.loginHost = window.location.host;
    // this.loginHost = "senses.hthai-clienteling.asia";
    // this.loginHost = "cbreconnect.hthai-clienteling.asia";
    console.log("=== domain ===", this.loginHost);

    //   this.getDefaultOrganizationDetails();
    //   setTimeout(() => {
    //     this.getOrganizationDetails();
    //   }, 1000);

    this.resetForm = new FormGroup({
      newPassword: new FormControl('', [Validators.required]),
      confirmPassword: new FormControl('', [Validators.required])
    })

    let langData = localStorage.getItem('lang');
    if (langData) {
      this.translocoService.setActiveLang(langData);
    } else {
      this.translocoService.setActiveLang('en');
    }


    this.route.params.subscribe(r => {
      this.uid = r['uuid'];
    })

    this.loginHost = window.location.host;
    console.log("Location URL", window.location.host);

    switch (this.loginHost) {
      case 'cbreconnect.hthai-clienteling.asia': {
        console.log("case1");
        this.showCbreResetPassword = true;
        break;
      }
      case 'senses.hthai-clienteling.asia': {
        this.showSensesResetPassword = true;
        console.log("case2");
        break;
      }
      default: {
        this.showDefaultResetPassword = true;
        //  this.showSensesResetPassword = true;
        console.log("default");
        break;
      }
    }
  }


  changeActiveLanguage(langCode: string) {
    this.translocoService.setActiveLang(langCode);
  }

  getDefaultOrganizationDetails() {
    this.appService.getOrganisationDetailsForTheme(1, 'id').subscribe(r => {
      this.defaultOrganizationDetail = r.data.organisationDetails;
      console.log("=== Default Organisation Detail ===", this.defaultOrganizationDetail);
      if (this.defaultOrganizationDetail.themeConfig && this.defaultOrganizationDetail.themeConfig != '') {
        this.data = this.defaultOrganizationDetail.themeConfig;
      }
    });
  }

  getOrganizationDetails() {
    this.appService.getOrganisationDetailsForTheme(this.loginHost, 'domain').subscribe(r => {
      this.organizationDetails = r.data.organisationDetails;
      console.log("=== Organisation Detail ===", this.organizationDetails);
      if (this.organizationDetails.themeConfig && this.organizationDetails.themeConfig != '') {
        this.data = this.organizationDetails.themeConfig;
      }
      this.loaded = true;
    });
  }


  // onSubmit() {
  //   if (this.resetForm.valid) {
  //     this.errMessage = '';
  //     let newPassword = this.resetForm.controls['newPassword'].value;
  //     let confirmPassword = this.resetForm.controls['confirmPassword'].value;
  //     if (newPassword === confirmPassword) {
  //       this.loading = true;
  //       this.authService.resetPassword({ ...this.resetForm.value, uid: this.uid }).subscribe(r => {
  //         this.loading = false;
  //         this.errMessage = r.message;
  //         this.viewForgetSubmitMsg(r)

  //         this.router.navigate(["/login"])
  //       }, err => {
  //         this.loading = false;
  //         this.errMessage = err.error.errors[0].message;
  //         this.viewForgetSubmitMsg(err)

  //       })
  //     } else {
  //       // this.errMessage = "Password & confirm password does not match!"
  //       this.viewForgetSubmitMsg(this.errMessage = "Password & confirm password does not match!")
  //     }

  //   }
  // }


  // viewForgetSubmitMsg(element: any) {
  //   let confirmBoxData: any = {
  //     title: '',
  //     message: '',
  //     iconClass: '',
  //     icon: '',
  //     approveButtonText: 'OK',
  //     approveButtonClass: "tis-btn-primary",
  //     cancelButtonText: '',
  //     cancelButtonClass: '',
  //   };

  //   if (element?.error?.errors?.length) {
  //     // Error case
  //     confirmBoxData.title = 'Error';
  //     confirmBoxData.message = element.error.errors[0].message;
  //     confirmBoxData.iconClass = "tis-text-danger";
  //     confirmBoxData.icon = "error";
  //     confirmBoxData.approveButtonClass = "tis-btn-danger";
  //   } else {
  //     // Success case
  //     confirmBoxData.title = 'Reset Confirmed';
  //     confirmBoxData.message = element.message;
  //     confirmBoxData.iconClass = "tis-text-success";
  //     confirmBoxData.icon = "check_circle";
  //     confirmBoxData.approveButtonClass = "tis-btn-primary";
  //   }

  //   const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
  //     width: "450px",
  //     panelClass: ['tis-simple-confirmation'],

  //     data: confirmBoxData,
  //     disableClose: true,
  //   });

  //   dialogRef.afterClosed().subscribe((result) => {
  //     console.log("The dialog was closed with result:", result);
  //   });
  // }
  onSubmit() {
    if (this.resetForm.valid) {
      this.errMessage = '';
      const newPassword = this.resetForm.controls['newPassword'].value;
      const confirmPassword = this.resetForm.controls['confirmPassword'].value;
  
      if (newPassword === confirmPassword) {
        this.loading = true;
        this.authService.resetPassword({ ...this.resetForm.value, uid: this.uid }).subscribe(
          (response) => {
            this.loading = false;
            this.errMessage = response.message;
            this.viewForgetSubmitMsg(response, false);  // false means success
            this.router.navigate(['/login']);
          },
          (error) => {
            this.loading = false;
            this.errMessage = error?.error?.errors?.[0]?.message || 'An unexpected error occurred';
            this.viewForgetSubmitMsg(error, true); // true means error
          }
        );
      } else {
        this.errMessage = 'Password & confirm password does not match!';
        this.viewForgetSubmitMsg({ message: this.errMessage }, true);  // true means error
      }
    }
  }
  
  viewForgetSubmitMsg(element: any, isError: boolean = false) {
    if (typeof element === 'string') {
      element = { message: element };
    }
  
    const confirmBoxData: any = {
      title: isError ? 'Error' : 'Reset Confirmed',
      message: element.message,
      iconClass: isError ? 'tis-text-danger' : 'tis-text-success',
      icon: isError ? 'error' : 'check_circle',
      approveButtonText: 'OK',
      approveButtonClass: isError ? 'tis-btn-danger' : 'tis-btn-primary',
      cancelButtonText: '',
      cancelButtonClass: '',
    };
  
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      width: '450px',
      panelClass: ['tis-simple-confirmation'],
      data: confirmBoxData,
      disableClose: true,
    });
  
    dialogRef.afterClosed().subscribe((result) => {
      console.log('The dialog was closed with result:', result);
    });
  }
  
  


  setBold(bold: boolean) {
    if (bold) {
      return 'bolder !important';
    }
    else {
      return '';
    }
  }

  setBorderRadius(isRadius: boolean, radius = '0px') {
    if (isRadius) {
      return '';
    }
    else {
      return radius;
    }
  }

  setWidth(isRadius: boolean, width = '20px') {
    if (this.isMobile) {
      return width;
    }
    else {
      if (isRadius) {
        return '100%';
      }
      else {
        return width;
      }
    }
  }

  setHeight(isRadius: boolean, height = '20px') {
    if (isRadius) {
      return '';
    }
    else {
      return height;
    }
  }
  setBorder(color: string, isBorder = this.themeConfig.bgAndFontColor.default.btnBorder) {
    if (isBorder) {
      return `1px solid ${color} !important`;
    }
    else {
      return ``;
    }

  }
  setHeaderBackground(degree = 90, primary = this.themeConfig.bgAndFontColor.login.desktop.bg[0], secondary = this.themeConfig.bgAndFontColor.login.desktop.bg[1]) {
    return `linear-gradient(${degree}deg, ${primary}, ${secondary}) !important`;
  }





}
